<ng-container *transloco="let t">
  @if (showBanner) {
    <div>
      <div class="cookie-banner" data-test-id="cookie-banner.container" [class.cookie-banner-small]="!isExpanded" [class.cookie-banner-large]="isExpanded">
        @if (!isExpanded) {
          <div class="cookie-banner-content-small">
            <div class="cookie-text">
              <p data-test-id="cookie-banner.text-txt">
                {{ t('cookie.bannerText') }}
                <a href="{{ t('cookie.cookiePolicyPath') }}" target="_blank" rel="noopener" data-test-id="cookie-banner.policy-link">{{ t('cookie.cookiePolicy') }}</a>.
              </p>
            </div>
            <div class="cookie-banner-buttons">
              <button
                type="button"
                class="btn-secondary"
                [class.btn-sm]="buttonSize === 'sm'"
                [class.btn-md]="buttonSize === 'md'"
                data-test-id="cookie-banner.manage-btn"
                (click)="toggleBanner()">
                {{ t('cookie.managePreferences') }}
              </button>
              <button
                type="button"
                class="btn-primary"
                [class.btn-sm]="buttonSize === 'sm'"
                [class.btn-md]="buttonSize === 'md'"
                data-test-id="cookie-banner.accept-all-btn"
                (click)="setCookiePreferences()">
                {{ t('cookie.acceptAll') }}
              </button>
            </div>
          </div>
        }
        @if (isExpanded) {
          <div class="cookie-banner-content-large">
            <div class="flex flex-row justify-between items-center">
              <div>
                <label class="toggle-label justify-between">
                  <span class="toggle-span toggle-container disabled">
                    <input
                      type="checkbox"
                      [checked]="true"
                      [(ngModel)]="allowRequiredCookies"
                      data-test-id="cookie-banner.required-toggle"
                      disabled="disabled" />
                    <div class="toggle-text">
                      <span class="affirmative">{{ t('cookie.on') }}</span>
                      <span class="negative">{{ t('cookie.off') }}</span>
                    </div>
                  </span>
                  <span data-test-id="cookie-banner.required-label-txt">{{ t('cookie.requiredCookies') }}</span>
                </label>
              </div>
              <button
                type="button"
                class="btn-primary btn-md expand-button mr-20 large-screen"
                data-test-id="cookie-banner.save-btn"
                (click)="setCookiePreferences()">
                {{ t('cookie.saveSelection') }}
              </button>
            </div>
            <p>{{ t('cookie.requiredCookiesText') }}</p>
            <p>{{ t('cookie.requiredCookiesText2') }}</p>
            <div class="pt-7 pb-3">
              <label class="toggle-label w-76 justify-start">
                <span class="toggle-span toggle-container" [class.disabled]="false">
                  <input
                    type="checkbox"
                    [checked]="true"
                    [(ngModel)]="allowAnalyticsCookies"
                    data-test-id="cookie-banner.analytics-toggle" />
                  <div class="toggle-text">
                    <span class="affirmative">{{ t('cookie.on') }}</span>
                    <span class="negative">{{ t('cookie.off') }}</span>
                  </div>
                </span>
                <span data-test-id="cookie-banner.analytics-label-txt">{{ t('cookie.analytics') }}</span>
              </label>
            </div>
            <p>{{ t('cookie.analyticsText') }}</p>
            <p>{{ t('cookie.analyticsText2') }}</p>
            <button
              type="button"
              class="btn-primary btn-md expand-button hidden small-screen"
              data-test-id="cookie-banner.save-mobile-btn"
              (click)="setCookiePreferences()">
              {{ t('cookie.saveSelection') }}
            </button>
          </div>
        }
      </div>
    </div>
  }
</ng-container>
